import Vue from 'vue'
import Antd, { Collapse } from 'ant-design-vue'

Vue.component('Collapse', Collapse)

Vue.use(Antd)
